import { useEffect, useState } from 'react';

import { SpecialDaysProps } from '../types/types';

const useFetchSpecialDay = (wordPressSiteURL: string,) => {
	const [events, setEvents] = useState<SpecialDaysProps[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		const fetchPosts = async () => {
			setError(false);
			try {
				const response = await fetch(`${wordPressSiteURL}/wp-json/wp/v2/special_days?acf_format=standard&per_page=100`);

				if (!response.ok) {
					throw new Error('Network response was not ok');
				}

				const data = await response.json();
				const acfArray = data.map((item: { acf: SpecialDaysProps; }) => item.acf);

				setEvents(acfArray);
			} catch (error) {
				setError(true);
				console.error('Failed to fetch posts:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchPosts();
	}, [wordPressSiteURL]);

	return { events, loading, error }; // Return totalPosts as well
};

export default useFetchSpecialDay;